import PaymentDueSummary from "./PaymentDueSummary";
import { connect } from "react-redux";
import {
	getQuoteTotalWithDelta,
	getSavingsData,
	getTotalExcludedTaxes,
} from "app/pages/Booking/bookingSelectors";
import {
	calculatePartialPaymentAmount,
	getBookingPaymentMode,
	getPayNowAmount,
} from "app/pages/Booking/Payment/paymentSelector";

const mapStateToProps = state => {
	const payAtPropertyAmount = getTotalExcludedTaxes(state);
	const total = getQuoteTotalWithDelta(state);

	return {
		payNowAmount: getPayNowAmount(state),
		total,
		savingsTotalAmount: getSavingsData(state).amountSaved || 0,
		paymentMode: getBookingPaymentMode(state),
		mensualite2Fois: calculatePartialPaymentAmount(state),
		payAtPropertyAmount,
	};
};

export default connect(mapStateToProps)(PaymentDueSummary);
